import {ROOT_URL} from '../../config';
import request, {uploadBulkRedirects} from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {errorToastrOptions} from '../../config';
import {downloadCSV} from '../../components/helpers/helpers';
import {
    fetchedRedirect,
    createdRedirect,
    updatedRedirect,
    deletedRedirect,
    fetchedStatuses,
    getBulkUploadErrors,
    bulkRedirectsUploaded
} from './actions';

export function fetchRedirect(redirectId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/redirects/${redirectId}`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedRedirect(response.data)));
    }
}

export function fetchStatuses() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/redirect-statuses`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedStatuses(response.data)));
    }
}

export function createRedirect(redirect) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/redirects`,
            method: 'POST',
            data: {
                redirect_from: redirect.redirect_from,
                redirect_to: redirect.redirect_to,
                status: redirect.status.toString(),
                site_id: redirect.site_id,
            }
        };
        return request(options, dispatch)
            .then(response => dispatch(createdRedirect(response)))
            .then(() => toastr.success('Success!', 'The redirect has been created.'))
            .then(() => dispatch(push(`/redirects`)));
    }
}

export function updateRedirect(redirect) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/redirects/${redirect.id}`,
            method: 'PUT',
            data: {
                redirect_from: redirect.redirect_from,
                redirect_to: redirect.redirect_to,
                status: redirect.status.toString(),
                site_id: redirect.site_id,
            }
        };
        return request(options, dispatch)
            .then(response => dispatch(updatedRedirect(redirect)))
            .then(() => toastr.success('Success!', 'Redirect "' + redirect.id + '" has been updated.'));
    }
}

export function deleteRedirect(redirect) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/redirects/${redirect}`,
            method: 'DELETE'
        };
        return request(options, dispatch)
            .then(response => dispatch(deletedRedirect(redirect)))
            .then(() => toastr.success('Success!', 'Redirect ' + redirect + ' has been deleted.'))
    }
}

export function uploadBulkRedirectsDocument(doc) {
    return (dispatch) => {
        uploadBulkRedirects(dispatch, doc, response => {
            if (response.data.errors.length > 0) {
                dispatch(getBulkUploadErrors(response.data.errors));
                toastr.error('Error!', response.data.result, errorToastrOptions);
                downloadCSV(response.data.errors);
            } else {
                dispatch(bulkRedirectsUploaded());
                dispatch(push(`/redirects`));
                toastr.success('Success!', 'The document with bulk redirects has been successfully uploaded!');
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/containers/redirects/thunks.js